import { AppFooter, AppNavbar } from "../../components";
import { HomeScreen1, HomeScreen1New, HomeScreen2, HomeScreen2New, HomeScreen3, HomeScreen3New, HomeScreen4 } from "../../containers";
import "./Home.css";


const Home = () => {

    return (
        <div className="home">
            <AppNavbar/>
            <HomeScreen1New/>
            <HomeScreen2New/>
            <HomeScreen3New/>
            <HomeScreen1/>
            <AppFooter/>


          
           {/* <HomeScreen2/> */}
           {/* <HomeScreen3/> */}
           {/* <HomeScreen4/> */}
            {/* <HomeScreen2/> */}
        </div>
    )
};

export default Home;